// extracted by mini-css-extract-plugin
export var attribution = "_9d-4";
export var authorName = "_9d-5";
export var quote = "_9d-3";
export var testimonial = "_9d-2";
export var trustedBy = "_9d-0";
export var trustedByLabel = "_9d-1";